(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebf1f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebf1f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hkLG6", function(module, exports) {
const ctaForm = document.querySelector(".product-form-wrapper .product-form__buttons-row");
const productInfoContainer = document.querySelector(".product__info-container");
const threshold = ctaForm?.getBoundingClientRect().bottom + window.scrollY;
if (!productInfoContainer || window.innerWidth > 1199) return;
function handleStickyState() {
    const scroll = window.scrollY.toFixed(2);
    if (scroll > threshold) productInfoContainer.classList.add("product__info-container--sticky-cta");
    else productInfoContainer.classList.remove("product__info-container--sticky-cta");
}
handleStickyState();
window.addEventListener("scroll", handleStickyState);

});

parcelRegister("89B4B", function(module, exports) {
function initSwiper() {
    const swiperEls = document.querySelectorAll(".swiper[data-swiper]");
    swiperEls.forEach((swiperEl)=>{
        if (!swiperEl.classList.contains("connected-products") || window.innerWidth < 990) return;
        const options = JSON.parse(swiperEl.dataset.swiper || {});
        const swiper = new Swiper(swiperEl, {
            ...options
        });
        const swiperInitEvent = new CustomEvent("swiper-initiated");
        document.dispatchEvent(swiperInitEvent);
    });
}
if (!Swiper) return;
window.addEventListener("load", initSwiper);
[
    "loaded-more-items",
    "loaded-recommendations"
].forEach((event)=>{
    document.addEventListener(event, ()=>{
        initSwiper();
    });
});
var $5efbebf9759446f3$export$2e2bcd8739ae039 = initSwiper;

});

parcelRegister("j7sbP", function(module, exports) {
const facetsContainer = document.querySelector(".facets-container");
const collectionWrapper = document.querySelector(".collection-wrapper");
if (!facetsContainer) return;
let facetsHeight = getComputedStyle(facetsContainer).height;
let threshold = +(+facetsContainer?.getBoundingClientRect().bottom + +window.scrollY).toFixed(2);
function handleStickyFilter() {
    const scroll = +window.scrollY.toFixed(2);
    if (scroll > threshold) {
        collectionWrapper.style.setProperty("--facets-height", facetsHeight);
        collectionWrapper.classList.add("facets-sticky");
    } else {
        collectionWrapper.style.setProperty("--facets-height", 0);
        collectionWrapper.classList.remove("facets-sticky");
    }
}
handleStickyFilter();
window.addEventListener("scroll", handleStickyFilter);

});

parcelRequire("hkLG6");
parcelRequire("89B4B");
parcelRequire("j7sbP");
function $7b6580275555a38e$var$initCollectionSwatches() {
    const swatches = document.querySelectorAll(".card-information .connected-product-slide");
    function handleSetSwatchImage() {
        const swatchSlide = this;
        const swatchImageSrc = swatchSlide.dataset.featuredImage.replace(/.*?(\/\/cdn.*)/, "$1");
        const cardWrapper = swatchSlide.closest(".card-wrapper");
        const cardImage = cardWrapper.querySelector(".card--product img:last-child");
        let cardImageInitSrc = cardWrapper.getAttribute("data-current-src");
        let cardImageInitSrcsetContent = cardImage.getAttribute("srcset");
        if (!cardImageInitSrc) {
            cardImageInitSrc = cardImage.currentSrc.replace(/.*?(\/\/cdn.*)/, "$1");
            cardWrapper.setAttribute("data-current-src", cardImageInitSrc);
        }
        if (!cardWrapper.getAttribute("data-original-srcset")) cardWrapper.setAttribute("data-original-srcset", cardImageInitSrcsetContent);
        cardImage.setAttribute("srcset", swatchImageSrc);
        cardWrapper.classList.add("focus-connected-product");
        cardWrapper.classList.remove("focus-second-image");
    }
    function handleUnsetSwatchImage() {
        const swatchSlide = this;
        const cardWrapper = swatchSlide.closest(".card-wrapper");
        const cardImage = cardWrapper.querySelector(".card--product img:last-child");
        const originalSrcset = cardWrapper?.dataset.originalSrcset;
        if (originalSrcset) cardImage.setAttribute("srcset", originalSrcset);
        cardWrapper.classList.remove("focus-connected-product");
        cardWrapper.classList.add("focus-second-image");
    }
    swatches.forEach((swatch)=>{
        swatch.addEventListener("mouseenter", handleSetSwatchImage);
        swatch.addEventListener("mouseleave", handleUnsetSwatchImage);
    });
}
window.addEventListener("load", $7b6580275555a38e$var$initCollectionSwatches);
[
    "swiper-initiated",
    "loaded-recommendations"
].forEach((event)=>{
    document.addEventListener(event, ()=>{
        $7b6580275555a38e$var$initCollectionSwatches();
    });
});
// Product page
const $7b6580275555a38e$var$pdpSwatches = document.querySelectorAll(".pdp-connected-product");
const $7b6580275555a38e$var$swatchesHeaderPlaceholder = document.querySelector(".hovered-swatch-name");
function $7b6580275555a38e$var$setHeader() {
    const swatch = this;
    const swatchHeading = swatch.getAttribute("data-connected-product-heading");
    $7b6580275555a38e$var$swatchesHeaderPlaceholder.innerText = swatchHeading;
    $7b6580275555a38e$var$swatchesHeaderPlaceholder?.classList.add("active");
}
function $7b6580275555a38e$var$unsetHeader() {
    $7b6580275555a38e$var$swatchesHeaderPlaceholder?.classList.remove("active");
}
$7b6580275555a38e$var$pdpSwatches.forEach((swatch)=>{
    swatch.addEventListener("mouseenter", $7b6580275555a38e$var$setHeader);
    swatch.addEventListener("mouseleave", $7b6580275555a38e$var$unsetHeader);
});


(function() {
    if (!document.querySelector("featured-collection-carousel")) return;
    const initSlider = ()=>{
        document.querySelectorAll(".js-recommendation-swiper").forEach((elem, index)=>{
            let mobileLayout = 1;
            if (elem.dataset.mobileLayout) mobileLayout = elem.dataset.mobileLayout;
            let slider = new Swiper(elem, {
                slidesPerView: mobileLayout,
                slidesPerGroup: 1,
                spaceBetween: 8,
                speed: 1000,
                navigation: {
                    nextEl: elem.querySelector(".product-recommendations__slider-nav .swiper-button-next"),
                    prevEl: elem.querySelector(".product-recommendations__slider-nav .swiper-button-prev")
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    750: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    },
                    1200: {
                        slidesPerView: 4,
                        slidesPerGroup: 4
                    }
                }
            });
        });
    };
    const initSection = ()=>{
        document.querySelectorAll("featured-collection-carousel").forEach((section)=>{
            const sectionResizeObserver = new ResizeObserver((entries)=>{
                const [entry] = entries;
                let top = $252e8dd9e11c753f$var$calcTop(section);
                if (section.querySelector(".product-recommendations__slider-nav")) section.querySelector(".product-recommendations__slider-nav").style.top = top + "px";
            });
            sectionResizeObserver.observe(section);
            initSlider();
        });
    };
    function swiperInit() {
        initSlider();
        initSection();
        subSliderInit(true);
        sliderInit(true);
        popupSliderInit(true);
    }
    document.addEventListener("shopify:section:load", function(e) {
        swiperInit();
    });
    swiperInit();
})();
const $252e8dd9e11c753f$var$calcTop = (section)=>{
    const imageWrapper = section.querySelectorAll(".card__inner");
    let top = 0;
    if (imageWrapper) top = imageWrapper[0].offsetHeight / 2;
    else top = 50;
    return top;
};


(function() {
    let connectedProductsContainer = document.querySelector(".pdp-connected-products-container");
    if (!connectedProductsContainer) return;
    const currentProduct = JSON.parse(connectedProductsContainer.dataset.product);
    const currentVariants = currentProduct.variants.map((v)=>({
            option1: v.option1,
            available: v.available
        }));
    let productVariants = document.querySelectorAll(".product-form__controls-group input[type='radio']");
    if (!productVariants) return;
    productVariants.forEach((input)=>{
        input.addEventListener("change", ()=>{
            checkAvailability(input.value);
        });
    });
    function checkAvailability(value) {
        let connectedProductsElement = document.querySelectorAll(".pdp-connected-product");
        if (!connectedProductsElement) return;
        connectedProductsElement.forEach((el, index)=>{
            const connectedProductData = el.dataset.connectedProduct;
            if (!connectedProductData) return;
            el.classList.remove("sold-out");
            let connectedProduct;
            try {
                connectedProduct = JSON.parse(connectedProductData);
            } catch (e) {
                console.warn("Invalid connected product JSON", e);
                return;
            }
            if (connectedProduct.id === currentProduct.id) connectedProduct.variants.forEach((variant, index)=>{
                if (variant.option1 === value) {
                    if (variant.option1 === currentVariants[index].option1) {
                        if (!currentVariants[index].available) {
                            variant.available = false;
                            el.classList.add("sold-out");
                        }
                    }
                }
            });
        });
    }
})();



})();
//# sourceMappingURL=parcel_scripts.js.map
